import { styled } from '@mui/material/styles';

export const FormWrapper = styled('form')`
  display: flex;
  flex-direction: column;
`;
